// Dependencies: swiper.js
import Swiper from 'swiper/bundle';

export default function singlePost(postId) {
    

    const removeIntroClass = () => {
        document.body.classList.remove('intro');
    }
    setTimeout(function(){
        removeIntroClass();
    },1500);


    postId = '#post-' + postId;
    const selector = postId+' .afg-single-slider';
    const nestedSelector = postId+' .afg-simple-slider';
    const metaDate = document.querySelector(postId+' .date');
    const metaDuration = document.querySelector(postId+' .duration');
    const title = document.querySelector(postId+' .title-wrapper');
    const excerpt = document.querySelector(postId+' .excerpt');
    const content = document.querySelector(postId+' .single-content');

    if(window.innerWidth < 992) {
        document.querySelector(selector).classList.remove('swiper');
        document.querySelector(selector + ' > .swiper-wrapper').classList.remove('swiper-wrapper');
        document.querySelectorAll(selector + ' > .swiper-wrapper > .swiper-slide').forEach(slide => {
            slide.classList.remove('swiper-slide');
        });
        nestedSlider();
        return;
    }

    let isTextActive = false;
    const mainSlider = new Swiper(selector, {
        loop:false,
        direction: 'vertical',
        speed: 1000,
        grabCursor: true,
        mousewheel: true,
        navigation: {
            nextEl: postId+' .single-button-next',
            prevEl: postId+' .single-button-prev',
        },
        on: {
            init: function () {
                nestedSlider();
                textInactive();
            },
            slideChange: function () {
                var currentSlide = this.activeIndex;
                var currentSlideObj = this.slides[currentSlide];
                var length = this.slides.length;
                
                if (currentSlide === 0) {
                    document.body.classList.add('fist-slide');
                } else {
                    document.body.classList.remove('fist-slide');
                }

                if (currentSlide === 1 && isTextActive === false) {
                    textActive();
                } else {
                    textInactive();
                }
                if (currentSlide === length - 1) {
                    document.body.classList.add('last-slide');
                } else {
                    document.body.classList.remove('last-slide');
                }
            }
        }

    });

    function textActive() {
        content.classList.add('afg-active');
        title.classList.remove('afg-active');
        excerpt.classList.remove('afg-active');
        isTextActive = true;
    }

    function textInactive() {
        content.classList.remove('afg-active');
        title.classList.add('afg-active');
        excerpt.classList.add('afg-active');
        isTextActive = false;
    }



    function nestedSlider() {
        new Swiper(nestedSelector, {
            loop:false,
            direction: 'horizontal',
            speed: 1000,
            slidesPerView: 1,
            spaceBetween: 10,
            nested: true,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            },
            navigation: {
                nextEl: '.related-button-next',
                prevEl: '.related-button-prev',
            },
        });
    }

}
